import React,{ useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import moment from "moment";
import "./index.css"

import { Dialog } from "primereact/dialog";
import { Sidebar } from "primereact/sidebar";

import Menu from "../../helpers/Menu";
import Table  from "../../helpers/Table";
import Button from "../../helpers/Button";
import Search from "./Components/Search";
import { CheckboxField } from "../../helpers";

import Loading from "../../common/Loading";
import CopyToClipboard from "../../common/CopyToClipboard";


import { getPayableAmount, includeInBudget } from "../../services/api/vendorPayment";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchStatus } from "../../services/redux/reducers/commonThunk";
import { getPMBranches } from "../../services/api/pmBranch";
import { fetchVendorPaymentsCashFlow, updateVendorPaymentCashFlowData } from "../../services/redux/reducers/cashFlow/cashFlow";
import { getDateString, isMobile, numberConversion, round } from "../../utils";
import _ from "lodash";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";


const CashFlow = () => {
    const [isSearchVisible, setIsSearchVisible] = useState(true)
    const [isPIVisible, setIsPIVisible] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isBankDetailsVisible, setIsBankDetailsVisible] = useState(false)

    const [displayedBankDetails, setDisplayedBankDetails] = useState([])
    const [sellerPIPunch, setSellerPIPunch] = useState([])
    const [selectedVendorPayments, setSelectedVendorPayments] = useState([])
    const [selectedVendorPaymentsAmount, setSelectedVendorPaymentsAmount] = useState(null)
    const [pmBranches, setPMBranches] = useState([])
    const [payableAmounts, setPayableAmounts] = useState([])

    const userDetails = useSelector(state => state.userDetails)
    const isTableLoading = useSelector(state => state.vendorPaymentsCashFlow.loading)
    const searchParams = useSelector(state => state.vendorPaymentsCashFlow.searchParams)
    const paginationParams = useSelector(state => state.vendorPaymentsCashFlow.paginationParams)
    const vendorPaymentsData = useSelector(state => state.vendorPaymentsCashFlow.vendorPaymentsCashFlowData)
    const sellerPIPunches = useSelector(state => state.vendorPaymentsCashFlow.sellerPIPunches)
    const companyBankAccounts = useSelector(state => state.vendorPaymentsCashFlow.companyBankAccounts)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const statusList = useSelector((state) => state.common.status)
    const actionMenu = useRef(null)

    const isMobileDevice = isMobile()

    const navigate = useNavigate()
    const dispatch = useDispatch()
   
    useEffect(() => {
        dispatch(fetchStatus())
        fetchPMBranches()
        fetchPayableAmount()

        dispatch(raiseToast({severity:'info', detail: "Credit vendor payments will be displayed only after verified from finance team", life: 9000}))
    }, [])

    useEffect(() => {
        let totalAmount = 0
        selectedVendorPayments?.map(eachVendorPayment => {
            totalAmount += eachVendorPayment?.amount
        })
        totalAmount = round(totalAmount)
        setSelectedVendorPaymentsAmount(totalAmount)
    }, [selectedVendorPayments])

    const fetchPMBranches = async () => {
        const pmBranchesResponse = await getPMBranches()

        if(pmBranchesResponse.failure){
            return dispatch(raiseToast({severity:'error', detail: pmBranchesResponse.data.error, life: 3000}))
        } else {
            console.log("pmBranchesResponse", pmBranchesResponse)
            setPMBranches(pmBranchesResponse.data)
        }
    }

    const fetchPayableAmount = async () => {
        const payableAmountResponse = await getPayableAmount()

        if(payableAmountResponse.failure){
            return dispatch(raiseToast({severity:'error', detail: payableAmountResponse.data.error, life: 3000}))
        } else {
            console.log("payableAmountResponse", payableAmountResponse)
            setPayableAmounts(payableAmountResponse.data)
        }
    }

    const getHeaderCheckbox = ()=>{
        const relatedVendorPayments = vendorPaymentsData?.filter(eachVendorPayment => !eachVendorPayment.isIncludedInBudget)
        return(
            <div className=""> <CheckboxField onChange={(e) => handleSelectClick(e)} checked={vendorPaymentsData?.length > 0 && relatedVendorPayments?.length === selectedVendorPayments?.length}/></div>
        )
    }

    const getBodyCheckbox = (row)=>{
        const relatedVendorPayment = selectedVendorPayments?.find(eachVendorPayment => eachVendorPayment?.vendorPaymentId === row?.vendorPaymentId)
        return(
            <CheckboxField onChange={() => handleCheckboxClick(row)} checked={relatedVendorPayment ? true : false} disabled={row?.isIncludedInBudget || row["sellerPO.statusId"] === 6} />
        )
    }

    const getPaymentNo = (row)=>{
        const date = moment(row?.createdAt).format("DD.MM.YYYY hh:mm")
        return(
            <div className='req-no-container' style={{position: "relative"}}>
            <div className='flex flex-row justify-content-center align-items-center'>
                {
                    row?.docNo ? 
                    <>
                        <p className='doc-no' style={{cursor: "pointer"}} >{row?.docNo}</p>
                        <CopyToClipboard text={row?.docNo} />
                    </>
                    : ""
                } 
            </div>
            <p className='mr-4 date'>{date}</p>
        </div>
        )
    }

    const getIncludeBody = (row)=>{
        return(
            <div className="text-center">
                {row?.isIncludedInBudget ? "Yes" : "No"}
            </div> 
        )
    }

    const getFinanceVerifiedBody = (row) => {
        return(
            <div className="text-center">
                {row?.isVerifiedByFinance ? "Yes" : "No"}
            </div> 
        )
    }

    const getCompanyBody = (row)=>{
        return(
            <div className="text-center">
                <div>{row["sellerPO.companies.companyName"]}</div>
            </div> 
        )
    }

    const getDocNo = (row)=>{
        const date = moment(row?.["sellerPO.createdAt"]).format("DD.MM.YYYY hh:mm")
        return(
            <div className='req-no-container' style={{position: "relative"}}>
            <div className='flex flex-row justify-content-center align-items-center'>
                {
                    row?.["sellerPO.docNo"] ? 
                    <>
                        <p className='doc-no' style={{cursor: "pointer", textDecoration: row["sellerPO.statusId"] === 6 ? 'line-through' : 'none' }} onClick={() => navigate(`/sellerpo/${row?.sellerPOId}`)} >{row?.["sellerPO.docNo"]}</p>
                        <CopyToClipboard text={row?.["sellerPO.docNo"]} />
                    </>
                    : ""
                } 
            </div>
            {/* <p className='mr-4 date'>{row["sellerPO.companies.companyName"]}</p> */}
            <p className='mr-4 date'>{date}</p>
        </div>
        )
    }

    const getStatusBody = (row)=>{
        const relatedStatus = statusList?.find(eachStatus => eachStatus.statusId === row?.statusId)
        return(
            <div className="text-center">
                <div>{relatedStatus?.status}</div>
            </div> 
        )
    }

    const getKAMBody = (row)=>{
        return(
            <div className="text-center">
                <div>{row["users.firstName"]+" "+row["users.lastName"]}</div>
            </div> 
        )
    }

    const getApprovedByBody = (row)=>{
        let approvedByUserName = ""
        if(row["approvedVendorUsers.firstName"]){
            approvedByUserName += row["approvedVendorUsers.firstName"]
        }
        if(row["approvedVendorUsers.lastName"]){
            approvedByUserName += " " + row["approvedVendorUsers.lastName"]
        }
        return (
            <div className="text-center">
                {
                    row?.approvedOrRejectedBy ?
                    (
                        <div className="text-center">
                            <div>{approvedByUserName}</div>
                        </div> 
                    ): "-"
                }
            </div>    
        )
    }

    const getBookingStatus = (row) => {
        const relatedSellerPIPunch = sellerPIPunches?.find(eachSellerPIPunch => eachSellerPIPunch?.sellerPIPunchId === row?.sellerPIPunchId)
        return (
            <div> { relatedSellerPIPunch?.bookedStatus ? "Booked" : "Not Booked" } </div>
        )
    }

    const getRemarksBody = (row)=>{
        return(
            <div className="text-center">
                <div>{row?.remarks ? row?.remarks : "-"}</div>
            </div> 
        )
    }

    const getPurchaseInvBody = (row)=>{
        const relatedSellerPIPunches = sellerPIPunches?.filter(eachSellerPIPunch => eachSellerPIPunch?.sellerPOId === row?.sellerPOId)
        return(
            <div>
                {
                    relatedSellerPIPunches?.length > 0 ?
                    (
                        <Button label="PI" className="small-btn" onClick={() => handlePIView(row)}/>
                    ): "-"
                }
            </div>
        )
    }

    const getBankDetailsBody = (row)=>{
        const relatedBankDetails = companyBankAccounts?.filter(eachBankDetails => eachBankDetails.branchId?.includes(row.branchId))
        return(
            <div>
                {
                    relatedBankDetails?.length > 0 ?
                    (
                        <a style={{cursor: "pointer", textDecoration: "underline"}} onClick={() => handleBankDetailsView(row)} > View </a>
                    ): "-"
                }
            </div>
        )
    }
 
    const getAmountBody = (row) =>{
        return(
            numberConversion(row.amount, numberLocale)
        )
    }

    const getPaymentDateBody = (row) =>{
        return(
            moment(row.paymentDate).format("DD.MM.YYYY")
        )
    }

    const getTdsAmount = (row) =>{
        return(
            numberConversion(row.tdsAmount, numberLocale)
        )
    }


    const tableColumns = [
        {
            header: getHeaderCheckbox, body: (row) => getBodyCheckbox(row)
        },
        {
            header: 'Payment No.', field: 'paymentNo', body:getPaymentNo, style:{ textAlign: "center",  minWidth: "130px" }
        },
        {
            header: 'Seller PO No', field: '', body: getDocNo, style:{ textAlign: "center",  minWidth: "130px"}
        },
        {
            header: 'Company', field: '', body: getCompanyBody, style:{ textAlign: "center", minWidth: "250px" }
        },
        {
            header : 'Payment Date', field : 'paymentDate', body: getPaymentDateBody, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'KAM', field: '', body : getKAMBody, style:{ textAlign: "center", minWidth: "150px" }
        },
        {
            header: 'Amount', field: 'amount', body: getAmountBody, style:{ textAlign: "center" }
        },
        {
            header: 'TDS', field: 'tdsAmount', body:getTdsAmount, style:{ textAlign: "center" , minWidth: "80px"}
        },
        {
            header: 'Mode', field: 'paymentMode', style:{ textAlign: "center", minWidth: "150px" }
        },
        /*{
            header: 'Included In Budget', field: getIncludeBody, style:{ textAlign: "center", minWidth: "150px" }
        },*/
        {
            header: 'Verified By Finance', field: getFinanceVerifiedBody, style:{ textAlign: "center" , minWidth: "150px"}
        },
        {
            header: 'Status', field: '', body:getStatusBody, style:{ textAlign: "center" }
        },
        {
            header: 'Approved By', field: '', body: getApprovedByBody, style:{ textAlign: "center", minWidth: "190px" }
        },
        {
            header: 'Purchase Inv', field: 'purchaseInv' , body: getPurchaseInvBody, style:{ textAlign: "center", minWidth: "110px" }
        },
        {
            header: 'Bank Details', field: '', body: getBankDetailsBody, style:{ textAlign: "center" , minWidth: "130px" }
        },
        {
            header: 'Booking Status', field: '', body: getBookingStatus, style:{ textAlign: "center", minWidth: "150px" }
        },
        {
            header: 'Note', field: '', style:{ textAlign: "center", minWidth: "80px" }
        },
        {
            header: 'Remarks', field: '', body: getRemarksBody, style:{ textAlign: "center", minWidth: "250px" }
        }
    ]

    const actionMenuItems = [
        {
            label: 'Include In Budget',
            icon: '',
            command : () => handleIncludeInBudgetClick(),
            permissions: [116]
        },
    ]

    const handlePIView = (row) => {
        const relatedSellerPIPunches = sellerPIPunches?.filter(eachSellerPIPunch => eachSellerPIPunch?.sellerPOId === row?.sellerPOId)
        setIsPIVisible(true)
        setSellerPIPunch(relatedSellerPIPunches)
    }

    const handleBankDetailsView = (row) => {
        const relatedBankAccounts = companyBankAccounts?.filter(eachBankDetails => eachBankDetails.branchId?.includes(row.branchId))
        setIsBankDetailsVisible(true)
        setDisplayedBankDetails(relatedBankAccounts)
    }

    const resetSelectedVendorPayments = () => {
        setSelectedVendorPayments([])
    }

    const handlePageChange = async (e) => {
        let vendorPaymentParams = { 
            ...searchParams,
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            isCashflowReq: true
        }

        dispatch(fetchVendorPaymentsCashFlow(vendorPaymentParams))
    }

    const handleUpdateVendorPayments = (vendorPaymentIds, updateObj) => {
        const updatedVendorPayments = vendorPaymentsData.map(eachVendorPayment => {
            if(vendorPaymentIds.includes(eachVendorPayment.vendorPaymentId)){
                return {...eachVendorPayment, ...updateObj}
            }
            return eachVendorPayment
        })

        dispatch(updateVendorPaymentCashFlowData(updatedVendorPayments))
    }

    const handleIncludeInBudgetClick = async () => {
        if(!searchParams.branchId){
            return dispatch(raiseToast({severity:'error', summary: 'Error', detail: "Select Branch", life: 3000}))
        }

        let selectedAmount = _.sumBy(selectedVendorPayments, 'amount')

        if(selectedPMBranch?.walletAmount - selectedAmount < -5000){
            return dispatch(raiseToast({severity:'error', detail: "Available budget is less than 500, cant process your request", life: 3000}))
        }

        setIsLoading(true)

        const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId) // not related its selected
        if (relatedVendorPaymentIds?.length > 0){
            const data = {
                vendorPaymentIds: relatedVendorPaymentIds,
                pmBranchId: searchParams.branchId
            }
            if(window.confirm("Are you sure you want to include in budget")){
                const response = await includeInBudget(data)
                if (response.failure){
                    dispatch(raiseToast({severity:'error', summary: 'Error', detail: "Payments has not Included in Budget", life: 3000}))
                }else {
                    const reduxUpdateObj = {
                        isIncludedInBudget: true,
                        pmBranchId: searchParams.branchId
                    }
                    handleUpdateVendorPayments(relatedVendorPaymentIds, reduxUpdateObj)
                    setSelectedVendorPayments([])
                    fetchPMBranches()
                    dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Payments has Included in Budget Successfully", life: 3000}))
                }
                console.log("repsonse", response)
            }
        }else{
            dispatch(raiseToast({severity:'warn', summary: 'Warning', detail: 'Select the Vendor Payments', life: 3000}))
        }
        
        setIsLoading(false)
    }

    const handleCheckboxClick = (row) => {
        const relatedVendorPayment = selectedVendorPayments?.find(eachVendorPayment => eachVendorPayment?.vendorPaymentId === row?.vendorPaymentId)
        if (relatedVendorPayment){
            const relatedVendorPayments = selectedVendorPayments?.filter(eachVendorPayment => eachVendorPayment?.vendorPaymentId !== relatedVendorPayment?.vendorPaymentId)
            setSelectedVendorPayments(relatedVendorPayments)
        }else {
            const relatedVendorPayments = [...selectedVendorPayments, row]
            setSelectedVendorPayments(relatedVendorPayments)
        }
    }

    const handleSelectClick = (e) => {
        const relatedVendorPayments = vendorPaymentsData?.filter(eachVendorPayment => !eachVendorPayment.isIncludedInBudget)
        if (e.checked){
            setSelectedVendorPayments(relatedVendorPayments)
        }else{
            setSelectedVendorPayments([])
        }
    }

    const selectedPMBranch = pmBranches.find(eachPMBranch => eachPMBranch.branchId === searchParams.branchId)
    const relatedPayableAmountArr = payableAmounts.filter(eachPayableObj => eachPayableObj.pmBranchId === selectedPMBranch?.branchId)

    let payableAmount = 0
    relatedPayableAmountArr.map(eachPayableObj => {
        if(["NON_CREDIT_PAYMENT", "CREDIT_PAYMENT", "CHEQUE_PAYMENT"].includes(eachPayableObj.paymentEligibleType)){
            payableAmount += eachPayableObj.sum
        }
    })
    payableAmount = round(payableAmount)

    let walletAmount = 0
    if(selectedPMBranch?.walletAmount){
        walletAmount = round(selectedPMBranch?.walletAmount, 2)
    }

    return (
        <div>
            <div className="vp-credit-non-credit-layout flex flex-column">
                <div className="flex flex-column md:flex-row md:justify-content-between">
                    <h4 className="m-2">VENDOR PAYMENT CASH FLOW</h4>
                    <div className="flex justify-content-end md:justify-content-between">
                        <div className="mr-5">
                            <p className="my-2" style={{fontSize: "15px"}}>Selected Amount: {numberConversion(selectedVendorPaymentsAmount, numberLocale)}</p>
                        </div>
                        <div className="mr-5">
                            <p className="my-2" style={{fontSize: "15px"}}>Total Payable: {numberConversion(round(payableAmount), numberLocale)}</p>
                        </div>
                        <div className="mr-5">
                            <p className="my-2" style={{fontSize: "15px"}}>Budget Left: {numberConversion(parseFloat(walletAmount), numberLocale)}</p>
                        </div>
                        <div className="mr-2">
                            <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                            <Button className="h-2rem mb-2 p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                        </div>
                        <div>
                            <Button icon="pi pi-filter" className="h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Filter" onClick={() => { setIsSearchVisible(!isSearchVisible) }} />
                        </div>
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div className="" style={{ order: "1", width: isSearchVisible  && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'"}}>
                        <div className='p-card mb-0'>
                            <div className="flex-grow-1 petty-cash-table" >
                                <Table
                                    lazy
                                    page={paginationParams.pageNo}
                                    onPageChange={(e)=> handlePageChange(e)} 
                                    totalRecords={paginationParams.totalRecords}
                                    tableColumns={tableColumns}
                                    rows={paginationParams.recordsPerPage}
                                    data={vendorPaymentsData}
                                    scrollable={"true"}
                                    paginator
                                    excessPagesFound= {paginationParams.excessPagesFound}
                                    loading={isTableLoading}
                                    scrollHeight={"550px"}
                                />
                            </div>
                        </div>
                    </div>
                    {
                        isSearchVisible && !isMobileDevice &&
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                            <Search />
                        </div>
                    }

                    {
                        isSearchVisible && isMobileDevice &&
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                            <Sidebar position='right' visible={isSearchVisible} onHide={() => setIsSearchVisible(false)}>
                                <Search />
                            </Sidebar>
                         </div>
                    }
                    
                    <Dialog header="Purchase Invoice" visible={isPIVisible} style={{ width: '75vw', minHeight: '30vh' }} onHide={() => {setIsPIVisible(false); setSellerPIPunch([])}}>
                        <div className="ml-2 mr-2 mt-0 pt-0">
                            <div>
                                <div className="flex justify-content-between">
                                    <div className="flex flex-wrap py-2 w-full">
                                        <div className="flex justify-content-between flex-grow-1 font-bold text-sm header-style" style={{ borderBottom: '1px solid rgb(217 227 222)' }}>
                                            <div className="mt-1" style={{ width: '15%' }}>PI Punch</div>
                                            <div className="mt-1" style={{ width: '20%' }}>PI Number</div>
                                            <div className="mt-1" style={{ width: '12%' }}>PI Date</div>
                                            <div className="mt-1" style={{ width: '12%' }}>PI Uploaded Date</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Booking Status</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Booked Date</div>
                                            <div className="mt-1" style={{ width: '12%' }}>PI Document</div>
                                        </div>
                                        {
                                            sellerPIPunch?.map(eachSellerPIPunch => {
                                                return (
                                                    <div className="flex justify-content-between flex-grow-1  w-full data-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "13px" }}>
                                                        <div className="py-1 align-self-center" style={{ width: '15%' }}>
                                                            {eachSellerPIPunch?.PIDocNo}
                                                        </div>
                                                        <div className="py-1 align-self-center" style={{ width: '20%' }}>{eachSellerPIPunch?.sellerPINumber}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachSellerPIPunch?.sellerPIDate ? getDateString(eachSellerPIPunch.sellerPIDate) : ""}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachSellerPIPunch?.sellerPIUploadedDate ? getDateString(eachSellerPIPunch.sellerPIUploadedDate) : ""}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachSellerPIPunch?.bookedStatus ? "Booked" : "Not Booked"}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachSellerPIPunch?.bookedAt ? getDateString(eachSellerPIPunch.bookedAt) : ""}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>
                                                            { eachSellerPIPunch?.sellerPIDocProof ? <a href={ eachSellerPIPunch.sellerPIDocProof} target="_blank" >View</a> : "" }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>

                    <Dialog header="Bank Details" className="bank-details-dialog" visible={isBankDetailsVisible} style={{ width: '55vw', height: '30vh' }} onHide={() => {setIsBankDetailsVisible(false); setDisplayedBankDetails([])}}>
                        <div className="ml-2 mr-2 mt-0 pt-0">
                            <div>
                                <div className="flex justify-content-between">
                                    <div className="flex flex-wrap py-2 w-full">
                                        <div className="flex justify-content-between flex-grow-1 font-bold text-sm header-style" style={{ borderBottom: '1px solid rgb(217 227 222)' }}>
                                            <div className="mt-1" style={{ width: '15%' }}>Bank Name</div>
                                            <div className="mt-1" style={{ width: '25%' }}>Account Holder Name</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Account No</div>
                                            <div className="mt-1" style={{ width: '12%' }}>IFSC Code</div>
                                            <div className="mt-1" style={{ width: '12%' }}>Document</div>
                                        </div>
                                        {
                                            displayedBankDetails?.map(eachBankDetails => {
                                                return (
                                                    <div className="flex justify-content-between flex-grow-1 w-full data-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "13px" }}>
                                                        <div className="py-1 align-self-center" style={{ width: '15%' }}>{eachBankDetails?.bankName}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '25%' }}>{eachBankDetails?.holderName}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachBankDetails?.accNo}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>{eachBankDetails?.ifscCode}</div>
                                                        <div className="py-1 align-self-center" style={{ width: '12%' }}>
                                                            { eachBankDetails?.documentProof ? <a href={ eachBankDetails.documentProof} target="_blank" >View</a> : "" }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>

                    <Loading visible={isLoading} />
                </div>
            </div>
        </div>
    )
}

export default CashFlow;